// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7f5d96ff] .custom-switch{position:absolute;right:0;top:-24px}", ""]);
// Exports
module.exports = exports;
